import * as React from 'react';
import cx from 'classnames';
import get from 'lodash/get';
import pick from 'lodash/pick';
import { connect } from 'react-redux';
import { withToast } from 'components/Toast/Toast';
import styles from './RichAccordian.css';
import { Chevron } from 'components/Icons/Icons';
import Checkbox from 'components/Checkbox';
import NotificationBellImage from './NotificationBellImage/NotificationBell';
import { saveNotificationPreferences } from 'actions/webpushActions';
import { toggleItemChecked, toggleItemOpened } from 'actions/notifPrefsAccordionActions';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import { CheckBoxStatus } from '@rome/response/common/leaf/value/CheckBoxStatus';
import HowToUnblock from './HowToUnblock/HowToUnblock';
import { withRouter } from 'react-router';
import { objectToQueryParams } from 'utils/urlutils';
export var CheckboxSelectionStatus;
(function (CheckboxSelectionStatus) {
    CheckboxSelectionStatus["FULLY"] = "FULLY";
    CheckboxSelectionStatus["DESELECTED"] = "DESELECTED";
    CheckboxSelectionStatus["PARTIALLY"] = "PARTIALLY";
})(CheckboxSelectionStatus || (CheckboxSelectionStatus = {}));
export class RichAccordion extends React.PureComponent {
    constructor(props) {
        super(props);
        this.saveTabItemPreference = (tabItem, checked) => {
            const params = get(tabItem, 'value.checkbox.action.params', {});
            const { SELECTED, UNSELECTED, requestBody } = pick(params, ['SELECTED', 'UNSELECTED', 'requestBody']);
            requestBody.status = checked ? UNSELECTED : SELECTED;
            const queryParams = get(this, 'props.location.query');
            if (queryParams) {
                const qParams = objectToQueryParams(queryParams);
                if (qParams) {
                    requestBody.query = qParams;
                }
            }
            this.props.saveNotificationPreferences(requestBody).catch(() => {
                this.props.toast.show({
                    message: stringTemplate('saveNotificationPreferencesError')
                });
            });
        };
        this.isTabOpen = value => (!value.hasOwnProperty('opened') && value.autoExpand) || value.opened;
        // TODO: need to debounce this event
        this.toggleItemChecked = (index) => ({ checked }) => {
            this.props.toggleItemChecked(index, checked);
            const { items } = this.props.notifPrefsAccordion;
            // TODO: ensure sequential resolving of the api calls, when called multiple times
            this.saveTabItemPreference(items[index], checked);
        };
        this.toggleItemOpened = (index) => () => {
            this.props.toggleItemOpened(index);
        };
    }
    renderInfo() {
        const isBlocked = this.checkIsBlocked();
        const header = get(this.props, 'widget.header');
        const showHeader = get(header, 'value.showHeader');
        const headerText = get(header, 'value.titleValue.text');
        const { items } = this.props.notifPrefsAccordion;
        const someSelected = items.some(item => get(item, 'value.checkbox.value.status') === CheckBoxStatus.SELECTED ||
            get(item, 'value.checkbox.value.status') === CheckBoxStatus.PARTIAL);
        if (headerText) {
            const headerTextElement = <p className={styles['infoHeaderText']}>{headerText}</p>;
            if (isBlocked || showHeader) {
                /** Checking if one of the tab items is in the selected state and hence not show the warning text */
                if (!isBlocked && showHeader && someSelected) {
                    return null;
                }
                return headerTextElement;
            }
            if (!isBlocked && !someSelected) {
                return headerTextElement;
            }
        }
        return null;
    }
    checkIsBlocked() {
        const params = get(this.props, 'widget.params');
        const isBlocked = get(params, 'isBlocked');
        return isBlocked;
    }
    render() {
        const { items } = this.props.notifPrefsAccordion;
        return (<div className={styles['content-col']}>
				<section className={styles['content']}>
					<div className={styles['prefs-card']}>
						<div className={styles['prefs-section']}>
							<ul className={styles['prefs-list']}>
								{
        // TODO: refactor this to use a nested tree structure instead to construct the accordion hierarchy
        items.map(({ value, parentIndex, hasChildren }, index) => {
            if (parentIndex !== -1) {
                return null;
            }
            return (<li key={index} className={cx({ [styles['disabled']]: get(value, 'disabled') })}>
												<section className={styles['heading-section']}>
													<Checkbox className={styles['checkbox']} onChange={this.toggleItemChecked(index)} checked={get(value, 'checkbox.value.status') === CheckBoxStatus.SELECTED} partial={get(value, 'checkbox.value.status') === CheckBoxStatus.PARTIAL}/>
													<div className={cx(styles['right-section'], { [styles['expanded']]: this.isTabOpen(value) })} onClick={this.toggleItemOpened(index)}>
														<div className={styles['text-section']}>
															<div className={styles['heading']}>{get(value, 'text')}</div>
															<div className={styles['subheading']}>{get(value, 'subtext')}</div>
														</div>
														<Chevron className={cx(styles['chevron-icon'], get(value, 'opened')
                ? styles['chevron-icon-rotate-up']
                : styles['chevron-icon-rotate-down'])} fill="#878787" width={9} height={11}/>
													</div>
												</section>
												{value && this.isTabOpen(value) && hasChildren && (<section className={styles['subheading-section']}>
														<ul>
															{items.map(({ value, parentIndex }, i) => {
                if (parentIndex !== index) {
                    return null;
                }
                return (<li key={`${i}`} className={cx({ [styles['disabled']]: get(value, 'disabled') })}>
																		<Checkbox onChange={this.toggleItemChecked(i)} checked={get(value, 'checkbox.value.status') === CheckBoxStatus.SELECTED} className={styles['item-checkbox']} label={<div className={styles['text-section']}>
																					<p>{get(value, 'text')}</p>
																					{get(value, 'showWarning') && get(value, 'warningText') && (<span className={styles['info-text']}>{get(value, 'warningText')}</span>)}
																				</div>}/>
																	</li>);
            })}
														</ul>
													</section>)}
											</li>);
        })}
							</ul>
							<div className={styles['prefs-graphic']}>
								<NotificationBellImage items={items} widgetData={this.props.widget}/>
								{this.renderInfo()}
								{this.checkIsBlocked() && <HowToUnblock className={styles['how-to-unblock']}/>}
							</div>
						</div>
					</div>
				</section>
			</div>);
    }
}
const mapStateToProps = (state) => {
    return {
        notifPrefsAccordion: state.notifPrefsAccordion
    };
};
const mapDispatchToProps = {
    saveNotificationPreferences,
    toggleItemChecked,
    toggleItemOpened
};
export default connect(mapStateToProps, mapDispatchToProps)(withToast(withRouter(RichAccordion)));
